import { StaticPageResponse } from 'src/shared/cms';
import { createRestClient } from '../restClient';

const client = createRestClient('/api', '/contentful');

export const fetchStaticPage = (appDomain: string, url: string): Promise<StaticPageResponse> =>
    client.get(`/cmspage/${appDomain}/${url}`).then(response => response.json());
